/* global define */
define('disclaimers',[
  'jquery',
  'Handlebars',
  'zipTools',
  'cookies',
  'lib/getParameterByName',
  'lib/util/langFromUrl',

  // side effect includes
  'bootstrapModal'
], function (
  $,
  Handlebars,
  zipTools,
  cookies,
  paramByName,
  langFromUrl
) {
  // unfortunately, we have several types of disclaimers, we need to account for each
  var __clickHandlerMsrpMpgBound = false; // exist in global disclaimers DCR
  var __clickHandlerLocalBound = false; // exist in individual DCRs, added to DOM via addLocalDisclaimers()
  var __clickHandlerViBound = false; // disclaimers from services, added via addVehicleInfoDisclaimers()
  var __initialized = false;
  // Until we modify our global disclaimers modal, we'll have to do this for vehicle specific MPG disclaimers
  // Should also be tied into our BATSiteConfig.customMpg
  var __disclaimerCodeXformMpg = function (code) {
    var parts = code.split(/-(.+)/);
    var model = parts[1];
    if (parts.indexOf('VIMPG') !== -1) {
      return BATSiteConfig.customMpg[model] ? BATSiteConfig.customMpg[model].disclaimer : 'VIMPG'; // eslint-disable-line no-undef
    }
    return code;
  };
  var __returnLabel = langFromUrl() === 'es' ? 'Subir' : 'Return';
  var __disLabel = langFromUrl() === 'es' ? 'Avisos legales' : 'Disclaimers';
  var __ariaPrefix = langFromUrl() === 'es' ? 'Avisos legales' : 'Disclaimer';

  // disclaimers service for modal
  var disclaimersService = {
    vehicleDisclaimers: [],
    standardDisclaimers: [],
    allDisclaimers: [],
    init: function () {
      this.buildGlobalDisclaimerModal();
      __initialized = true;
    },

    // BAT-2516. TDAs wanted a way to have all disclaimers, always visible as user browses the site
    showInlineDisclaimers: function () {
      var sd = (paramByName('showDisclaimers') === 'true') || cookies.getItem('showInlineDisclaimers') === 'true';
      var tomorrow = new Date((new Date()).valueOf() + 1000 * 3600 * 24);
      if (sd === true) {
        cookies.setItem('showInlineDisclaimers', 'true', tomorrow, '/', zipTools.getCrossDomainCookieDomain());
      }
      if (paramByName('showDisclaimers') === 'false') {
        cookies.setItem('showInlineDisclaimers', 'false', tomorrow, '/', zipTools.getCrossDomainCookieDomain());
        sd = false;
      }
      return sd;
    },

    buildGlobalDisclaimerModal: function () {
      var self = this;
      var resultTemplate = $('#disclaimers-global-modal').html();
      // ensure any local disclaimer updates that may have happened (and were added to self.adllDisclaimers) are included
      var resultHandlebar = Handlebars.hcompile(resultTemplate, self.allDisclaimers);
      $('#modal-wrap-disclaimers').html(resultHandlebar);
      var sd = self.showInlineDisclaimers();
    },

    appendDisclaimers: function () {
      var sd = this.showInlineDisclaimers();
      if (sd !== true) { return; } // ONLY DRAW IF sd.
      this.handleDisclaimers('vehicle', -1, true);
    },

    msrpMpgDigits: function (parentSelector, addAriaLabels) {

      var self = this;
      if (!__initialized) { self.init(); }
      var msrpDigit = $('#VIMSRP').data('digit');
      var msrpMiraiDigit = $('#MIRAIMSRP2019').data('digit');
      var mpgDigit = $('#VIMPG').data('digit');
      var mpgeDigit = $('#VIMPGE').data('digit');
      var mpgMiraiDigit = $('#VIMPGMIRAI').data('digit');
      var mpgChr = $('#CHRMPG').data('digit');

      var prefix = '';
      if (parentSelector && parentSelector.length) {
        prefix = parentSelector + ' ';
      }

      $(prefix + '.js-disclaimer-msrp').text(msrpDigit);
      $(prefix + '.js-disclaimer-msrpmirai').text(msrpMiraiDigit);
      $(prefix + '.js-disclaimer-mpg').text(mpgDigit);
      $(prefix + '.js-disclaimer-mpge').text(mpgeDigit);
      $(prefix + '.js-disclaimer-mpgmirai').text(mpgMiraiDigit);
      $(prefix + '.js-disclaimer-mpg-chr').text(mpgChr);

      $(prefix + '.js-disclaimer-lookup').each(function () {
        var $this = $(this);
        var code = $this.data('disclaimer');
        var fallback = $this.data('fallback');
        var digit = '';

        // Find the code... this really shouldn't be an element id, but we are
        // stuck with it for the time being.
        var $code = $('#' + __disclaimerCodeXformMpg(code));
        if ($code.length > 0) {
          digit = $code.data('digit');
        } else {
          $code = $('#' + fallback);
          if ($code.length > 0) {
            digit = $code.data('digit');
          }
        }
        if (addAriaLabels) {
          $this.attr('aria-label', (__ariaPrefix + ' ' + digit));
        }
        $this.text(digit);
      });

      if (!__clickHandlerMsrpMpgBound) {
        $(document).on('click.disclaimerServiceMsrpMpg', '.js-disclaimer-lookup, .js-disclaimer-msrp, .js-disclaimer-msrpmirai, .js-disclaimer-mpg, .js-disclaimer-mpge, .js-disclaimer-mpgmirai, .js-disclaimer-msrp-compare, .js-disclaimer-mpg-chr', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.handleDisclaimers('static', $(e.target).text());
        });
        __clickHandlerMsrpMpgBound = true;
      }
    },

    /*
      BAT-3173, BAT-3175: the benefits for prius prime are a special case. when the markup is prepared in the handlebars, the strings coming from tcom
      are passed through a helper called 'replaceDisclaimer' in lib/helpers where a unique key is applied to the dom elements and are later updated here,
      using the unique key to in inject the appropriate footnote number to corresponding disclaimer in modal.
    */
    updateBenefitsDisclaimers: function (parentSelector) {

      var self = this;
      if (!__initialized) { self.init(); }
      if (parentSelector) {
        // find the keys we need to replace:
        var keysToFind = $('[data-keyid]');// $(parentSelector).find('[keyid=!=""]');//$('[keyid=!=""]');
        keysToFind.each(function (index, item) {
          var key = $(item).data('keyid');
          for (var i = 0; i < self.allDisclaimers.length; i++) {
            var disclaimer = self.allDisclaimers[i];
            if (disclaimer.old_id && disclaimer.old_id === key) {
              $(item).text(disclaimer.disclaimer_id);
              $(item).on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var hasBenefitsModal = $('#modal-benefits').attr('class') === 'modal fade in';
                // DISCLAIMER LINKS NEED TO MANAGE THE PRESENCE OF THE BENEFITS MODAL.
                // close of benefits modal handled in vehicle-benefits.
                if (hasBenefitsModal) {
                  self.hasBenefitsModal = true;
                  $('#modal-benefits').modal('hide');
                }
                self.handleDisclaimers('static', $(e.target).text());
              });
            }
          }
        });
      }
    },

    // AN_inventory uses handleDisclaimers('vehicle')
    handleDisclaimers: function (type, id, force) {
      var self = this;
      var disclaimers = [];
      var disclaimersResults = [];

      if (self.isInline && !force) {
        // BAT-2360
        self.selectInline(id);
        return;
      }
      if ($('#disclaimers-global-modal').length || force === true) {
        if (type === 'static') {
          self.showAndSelect(id);
          return false;
        } else if (type === 'vehicle') {
          disclaimers = self.vehicleDisclaimers;

          // handle new data
          for (var i = 0; i < disclaimers.length; i++) {
            var scroll = (id === disclaimers[i].symbol) ? 'scroll' : '';
            var active = (id === disclaimers[i].symbol) ? 'active' : '';
            var result = {
              scroll_to: scroll,
              select: active,
              disclaimer_id: String(disclaimers[i].symbol),
              disclaimer_copy: disclaimers[i].description
            };
            disclaimersResults.push(result);
          }
          // Update Global Disclaimer Modal with all of our local disclaimers
          var resultTemplate = $('#disclaimers-global-modal').html();
          var resultHandlebar = Handlebars.hcompile(resultTemplate, disclaimersResults);
          $('#modal-wrap-disclaimers').html(resultHandlebar);
          if (force) {
            self.drawInlineDisclaimers(); // SPECIAL CONDITION FOR HANLDING INLINE DISCLAIMERS FROM RESULTS PAGE.
          }
          if (!force) {
            self.showAndSelect(id);
          }
        }
      }
    },

    drawInlineDisclaimers: function () {
      var self = this;
      var $existingDisclaimers = $('.inline-disclaimers');
      if ($existingDisclaimers.length) {
        $existingDisclaimers.remove();
      }
      self.isInline = true;
      var dislaimerContent = '<h2>' + __disLabel + '</h2>';
      dislaimerContent += $('#disclaimers-results').html();
      $('#main-wrapper-row').append('<div class="container inline-disclaimers"></div>');

      $('.inline-disclaimers').html(dislaimerContent);
      // override the local footnote disclaimer additions...
      $('.js-modal, .js-disclaimer-local, .js-disclaimer-vi').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.handleDisclaimers('local', $(e.target).text());
        return;
      });
    },

    // BAT-3173
    createDisclaimerCache: function () {
      this.allDisclaimers = [];
    },

    addLocalDisclaimers: function (selector, linkClass) {
      var self = this;
      if (!__initialized) { self.init(); }
      var selector = selector || 'body';
      var linkClass = linkClass || '.js-disclaimer-local';
      var staticOffset = (document.getElementById('disclaimers-global-modal').outerHTML.match(/static-disclaimer/g) || []).length;
      var count = 0;
      var localDisclaimerLinks = $(selector + ' ' + linkClass);
      var localDisclaimerContent = $('.js-disclaimer-local-content');
      var localDisclaimers = [];
      var disclaimersResults = [];

      // Turn local disclaimer DOM elements into objects
      localDisclaimerContent.each(function () {
        var tempObj = {
          teamsiteId: $(this).data('id'),
          symbol: count + staticOffset + 1,
          description: $(this).data('disclaimer-content')
        };
        count++;
        localDisclaimers.push(tempObj);
      });
      // push each one of those to our results
      for (var i = 0; i < localDisclaimers.length; i++) {
        var result = {
          disclaimer_id: String(localDisclaimers[i].symbol),
          disclaimer_copy: localDisclaimers[i].description
        };
        disclaimersResults.push(result);
      }
      // update links in DOM with proper disclaimer #
      // This allows for mutliple references to the same disclaimer:
      // we get the local teamsiteId first,
      // then match it up with the obj in our localDisclaimers arr that has the same teamsiteId
      $(localDisclaimerLinks).each(function () {
        var $this = $(this);
        var inlineTeamsiteId = Number($this.text());

        localDisclaimers.filter(function (curDisc) {
          if (curDisc.teamsiteId === inlineTeamsiteId) {
            $this.text(curDisc.symbol);
          }
        });
      });

      self.allDisclaimers = disclaimersResults;
      var resultTemplate = $('#disclaimers-global-modal').html();
      var resultHandlebar = Handlebars.hcompile(resultTemplate, disclaimersResults);
      $('#modal-wrap-disclaimers').html(resultHandlebar);
      var sd = self.showInlineDisclaimers();

      if (sd === true) {
        this.drawInlineDisclaimers();
      }

      if (!__clickHandlerLocalBound) {
        $(document).on('click.disclaimerServiceLocal', '.js-disclaimer-local, .js-disclaimer-tss', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.handleDisclaimers('static', $(e.target).text());
        });
        __clickHandlerLocalBound = true;
      }
    },

    // vehicle-info.js - Add disclaimers returned from services
    addVehicleInfoDisclaimers: function (newDisclaimers, selector) {
      var self = this;
      var selector = selector || '#js-template-trim-output';
      var staticOffset = (document.getElementById('disclaimers-global-modal').outerHTML.match(/static-disclaimer/g) || []).length;
      var addedLocallyCount = self.allDisclaimers.length;
      var finalDisclaimers = self.allDisclaimers;
      var newOffset = staticOffset + addedLocallyCount;
      var count = 0;

      for (var i = 0; i < newDisclaimers.length; i++) {
        var newObj = {
          old_id: newDisclaimers[i].service_id,
          disclaimer_id: count + newOffset + 1,
          disclaimer_copy: newDisclaimers[i].disclaimer_copy
        };
        count++;
        finalDisclaimers.push(newObj);
        // update proper DOM element with the proper disclaimer number
        $(selector + ' .js-disclaimer-vi[data-disclaimer-id="' + newObj.old_id + '"]').text(newObj.disclaimer_id);
      }

      var resultTemplate = $('#disclaimers-global-modal').html();
      var resultHandlebar = Handlebars.hcompile(resultTemplate, finalDisclaimers);
      self.allDisclaimers = finalDisclaimers;
      $('#modal-wrap-disclaimers').html(resultHandlebar);
      var sd = self.showInlineDisclaimers();

      if (sd === true) {
        self.drawInlineDisclaimers();
      }

      if (!__clickHandlerViBound) {
        $(document).on('click.disclaimerServiceVi', '.js-disclaimer-vi', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.handleDisclaimers('static', $(e.target).text());
        });
        __clickHandlerViBound = true;
      }
    },

    // INLINE DISCLAIMERS //BAT-2360
    selectInline: function (id) { // THIS HIJACKS THE CLICKS OF THE DISCLAIMER FOOTNOTE ITEMS.
      var self = this;
      id = id - 1;
      var $el = $('.disclaimer-entry').eq(id);
      self.lastEl = $el;
      var returnLinks = $('.return-link');
      returnLinks.each(function (idx, item) {
        item.remove(); // REMOVE ALL EXISING RETURN LINKS. this is a hammer, not a scalpel.
      });
      // remmber where we were:
      self.lastTop = $(window).scrollTop();
      // add return link:
      $('<div class="return-link"><a href="#">' + __returnLabel + '<i class="icon-arrow-up"></i></a></div>').insertAfter($el);
      // disclaimer element has active class added:
      $el.addClass('active');
      // more hammer:
      $el.siblings().removeClass('active');
      $el = $('.disclaimer-entry')[id];

      // ADD CLICKE HANDLER FOR RETURN LINK: //BAT-2360
      $('.return-link').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (self.lastEl) {
          self.lastEl.removeClass('active');
        }
        $('body, html').animate({
          scrollTop: self.lastTop
        }, 500);

        $('.inline-disclaimers').find('.return-link').remove();
        self.lastTop = null;
      });


      // for IE and firefox
      var timeoutID = window.setTimeout(function () {
        var inlineResults = $('.inline-disclaimers');
        inlineResults.scrollTop();
        if ($el !== undefined) {
          var top = $el.offsetTop ;// -112;
          if ($(window).width() <= 768) {
            var headerheight = 50;//
            var nvbh = $('.nav-sticky').height() + headerheight;
            top += nvbh;// account for mobile nav bar
          }
          var time = 750;
          $('body, html').animate({
            scrollTop: top
          }, time);
        }
      }, 0);
    },

    showAndSelect: function (id) {
      var self = this;
      if (self.isInline) {
        return;
      }
      $('#disclaimers-modal').modal('show');
      // BAT-3173. if the benefites modal was displaying, re-show it when this closes.
      var iconClose = $('#disclaimers-modal').find('.icon-close-modal');
      iconClose.on('click', function () {
        if (self.hasBenefitsModal) {
          setTimeout(function () {
            $('#modal-benefits').modal('show');
            self.hasBenefitsModal = false;
          }, 500);
        }
      });

      id = id - 1;
      var $el = $('.disclaimer-entry').eq(id);
      $el.addClass('active');
      $el.siblings().removeClass('active');
      $el = $('.disclaimer-entry')[id];

      // for IE and firefox
      var timeoutID = window.setTimeout(function () {
        $('#disclaimers-results').scrollTop();
        if ($el != undefined) {
          var top = $el.offsetTop - 112;
          var time = top * .5;
        }

        $('#disclaimers-results').animate({
          scrollTop: top
        }, time);
      }, 500);
    }
  };

  $(window).ready(function () {
    // hide disclaimers on page load
    if ($('.disclaimers-panel').hasClass('active')) {
      $('.disclaimers-panel').removeClass('active');
      $('.disclaimers-panel').hide();
      $('.disclaimers-link').find('i').removeClass('icon-arrow-down');
      $('.disclaimers-link').find('i').addClass('icon-arrow-up');
    }

    $('body').on('click', '.disclaimers-link', function (e) {
      e.preventDefault();
      if ($('.disclaimers-panel').hasClass('active')) {
        $('.disclaimers-panel').removeClass('active');
        $('.disclaimers-panel').hide();
        $('.disclaimers-link').find('i').removeClass('icon-arrow-down');
        $('.disclaimers-link').find('i').addClass('icon-arrow-up');
      } else {
        $('.disclaimers-panel').addClass('active');
        $('.disclaimers-panel').show();
        $('.disclaimers-link').find('i').removeClass('icon-arrow-up');
        $('.disclaimers-link').find('i').addClass('icon-arrow-down');
      }
    });

    // BAT-3862 fix for disclaimer popup on TSS page
    if ($('.js-disclaimer-local').length) {
      disclaimersService.addLocalDisclaimers();
    }
  });

  return disclaimersService;
});

